import React from "react";

import "antd/dist/antd.css";
import 'antd-country-phone-input/dist/index.css';
import "./App.less";

import Routes from "./routes";
import ViewportProvider from "./Context/viewport";
import  { ConfigProvider } from 'antd-country-phone-input';


function App() {
  return (
    <ConfigProvider locale={"en"}>
    <ViewportProvider>
      <Routes />
    </ViewportProvider>
    </ConfigProvider>
  );
}

export default App;
